module.exports = __webpack_public_path__ + "static/media/earth-video-smaller.cfab15a3.mp4";